import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Graph from 'vis-react';

import styles from './networkStyles.module.scss';
import * as networkUtils from './networkUtils';
import { EmptyPlaceholder } from '../EmptyPlaceholder';

export class Network extends Component {
  static propTypes = {
    noData: PropTypes.bool,
    isItemSelected: PropTypes.bool,
    graphData: PropTypes.object,
  };

  static defaultProps = {
    graphData: {
      nodes: [],
      edges: [],
    },
  };

  static networkOptions = {
    nodes: {
      shape: 'dot',
      // scaling: {
      //   label: {
      //     min: 8,
      //     max: 20,
      //   },
      // },
    },
    physics: { enabled: true },
    interaction: { dragNodes: false },
    layout: {
      hierarchical: {
        enabled: false,
        nodeSpacing: 150,
        levelSeparation: 250,
      },
      randomSeed: 6,
    },
  };

  static events = {
    select: function(event) {
      const { nodes, edges } = event;
      console.log(nodes, 'nodes');
      console.log(edges, 'edges');
    },
  };

  render() {
    return (
      <div className={styles.graphWrapper}>
        {this.props.noData && <EmptyPlaceholder />}
        <Graph
          graph={
            this.props.isItemSelected
              ? networkUtils.mapDataToGraphOptions(
                  this.props.graphData.nodes,
                  this.props.graphData.edges,
                  this.props.graphData.max_degree_participants,
                )
              : networkUtils.mockGraph
          }
          options={Network.networkOptions}
          events={Network.events}
        />
      </div>
    );
  }
}
